import React from 'react';
import { Facebook, Twitter, Linkedin, Mail, Link as LinkIcon, Share2, Instagram } from 'lucide-react';

interface ShareButtonsProps {
  url: string;
  title: string;
}

const ShareButtons: React.FC<ShareButtonsProps> = ({ url, title }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  
  // Função para copiar o link para a área de transferência
  const copyToClipboard = () => {
    navigator.clipboard.writeText(url);
    alert('Link copiado para a área de transferência!');
  };
  
  return (
    <div className="flex flex-col items-center">
      <h3 className="text-lg font-medium text-[#2a3c5c] mb-4 flex items-center">
        <Share2 size={18} className="mr-2" />
        Compartilhar este artigo
      </h3>
      
      <div className="flex flex-wrap justify-center gap-3">
        {/* Instagram */}
        <a 
          href="#"
          className="bg-gradient-to-tr from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] hover:opacity-90 text-white p-2 rounded-full transition-all duration-300"
          aria-label="Compartilhar no Instagram"
          onClick={(e) => {
            e.preventDefault();
            // Copia o link para a área de transferência
            navigator.clipboard.writeText(url);
            
            // Abre o Instagram no navegador
            window.open('https://www.instagram.com/direct/inbox/', '_blank');
            
            // Mostra uma mensagem de orientação
            alert('Link copiado para a área de transferência! Cole-o no chat do Instagram para compartilhar.');
          }}
        >
          <Instagram size={20} />
        </a>
        
        {/* WhatsApp */}
        <a 
          href={`https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#25D366] hover:bg-[#20bd5a] text-white p-2 rounded-full transition-colors duration-300"
          aria-label="Compartilhar no WhatsApp"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="currentColor"
            stroke="none"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
        </a>
        
        {/* Facebook */}
        <a 
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#1877F2] hover:bg-[#0e5fc0] text-white p-2 rounded-full transition-colors duration-300"
          aria-label="Compartilhar no Facebook"
        >
          <Facebook size={20} />
        </a>
        
        {/* Twitter */}
        <a 
          href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#1DA1F2] hover:bg-[#0c85d0] text-white p-2 rounded-full transition-colors duration-300"
          aria-label="Compartilhar no Twitter"
        >
          <Twitter size={20} />
        </a>
        
        {/* LinkedIn */}
        <a 
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#0A66C2] hover:bg-[#084b8e] text-white p-2 rounded-full transition-colors duration-300"
          aria-label="Compartilhar no LinkedIn"
        >
          <Linkedin size={20} />
        </a>
        
        {/* Email */}
        <a 
          href={`mailto:?subject=${encodedTitle}&body=${encodedTitle}%0A${encodedUrl}`}
          className="bg-[#D44638] hover:bg-[#b73022] text-white p-2 rounded-full transition-colors duration-300"
          aria-label="Compartilhar por email"
        >
          <Mail size={20} />
        </a>
        
        {/* Copiar link */}
        <button 
          onClick={copyToClipboard}
          className="bg-[#2a3c5c] hover:bg-[#4a6c9c] text-white p-2 rounded-full transition-colors duration-300"
          aria-label="Copiar link"
        >
          <LinkIcon size={20} />
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
